<template>
  <div id="app">
    <pageHeader v-if="!isHideHeadFoot" />
    <router-view />
    <pageFooter  v-if="!isHideHeadFoot"/>
    <pageFooter_p  v-if="isHideHeadFoot"/>
  </div>
</template>

<script>
import pageFooter from './components/pageFooter'
import pageFooter_p from './components/pageFooter_p'
import pageHeader from './components/pageHeader'
export default {
  name: 'App',
  components: {
    pageFooter,
    pageHeader,
    pageFooter_p
  },
  data() {
    return {
      isHideHeadFoot:false
    }
  },
  created(){
    let path=window.location.href;
    if (path.indexOf('platform')>-1) {
      this.isHideHeadFoot=true;
    }else{
      this.isHideHeadFoot=false;
    }
  },
  watch:{
    $route(){
      let path=window.location.href;
      if (path.indexOf('platform')>-1) {
        this.isHideHeadFoot=true;
      }else{
        this.isHideHeadFoot=false;
      }
    }
  },  
  mounted() {
  },
}
</script>

<style lang="less">
@import './index.less';
body{
	min-width: 1440px;
	// overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue